import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class List extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        listType: PropTypes.bool,
    };

    /**
     * 渲染组件
     */
    render() {
        let { content, listType } = this.props;
        const array = [];
        let list = [];

        if (!listType) {
            content = content.slice(0, 2);
        }

        content.forEach((item, index) => {
            list.push(
                <div className={styles.box_01_1}>
                    <h3 key={index} className={`${styles.text}`}>
                        {item.children && item.children.length > 0 ? (
                            <React.Fragment>
                                <a href={item.url} target="_blank" title={item.title} rel="noreferrer">
                                    {item.title}
                                </a>
                                {item.children.map((child, index) => (
                                    <React.Fragment key={index}>
                                        <a href={child.url} target="_blank" title={child.title} rel="noreferrer">
                                            {child.title}
                                        </a>
                                    </React.Fragment>
                                ))}
                            </React.Fragment>
                        ) : (
                            <a href={item.url} target="_blank" title={item.title} rel="noreferrer">
                                {item.title}
                            </a>
                        )}
                    </h3>
                </div>,
            );
            array.push(
                <div key={index} className={`${styles.hot} ${listType ? '' : styles.noList}`}>
                    {list && list.length > 0 ? list : ''}
                </div>,
            );
            list = [];
        });

        return <div style={{ position: 'relative', marginTop: `${listType ? '' : '20px'}` }}>{array}</div>;
    }
}

export default errorBoundary(List);
